<template>
  <svg style="width:100%; max-width: 400px;" viewBox="0 0 504 537" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M195.559 2.00003H403.98C424.306 2.00003 440.783 18.4611 440.783 38.7669V242.573C429.569 357.868 331.03 444.879 215.115 441.84C99.2007 438.801 5.36628 346.746 0.220958 231.022C-4.92436 115.297 80.3709 15.2939 195.559 2.00003ZM216.823 412.571C318.062 414.62 403.346 337.466 411.312 236.621L411.369 73.7598C411.29 50.3699 392.279 31.4549 368.866 31.4708H202.233C101.447 41.2394 25.7598 127.811 29.6299 228.895C33.5 329.979 115.585 410.522 216.823 412.571Z"
      fill="#00903C"
    />
    <g filter="url(#filter0_d)">
      <rect
        x="49.4664"
        y="17.7198"
        width="221.717"
        height="455.8"
        rx="32.1975"
        transform="rotate(-2 49.4664 17.7198)"
        fill="#DBDBDB"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M214.981 25.2431L214.856 21.6669L239.584 20.8034C251.431 20.3897 261.371 29.6586 261.785 41.5062L275.494 434.102C275.908 445.949 266.639 455.889 254.792 456.303L96.1762 461.842C84.3286 462.255 74.3889 452.987 73.9751 441.139L60.2654 48.5434C59.8517 36.6959 69.1206 26.7561 80.9682 26.3424L106.304 25.4576L106.429 29.0338C106.664 35.7475 112.296 40.9999 119.01 40.7654L203.249 37.8237C209.963 37.5893 215.215 31.9568 214.981 25.2431Z"
      fill="url(#paint0_linear)"
    />
    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="94" y="4" width="410" height="518">
      <path
        d="M94.5614 18.6064L485.569 4.95213L503.592 521.075L277.405 459L110.905 459L94.5614 18.6064Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M225.9 165.797C221.688 173.43 216.425 178.986 213 179.945C204.41 182.347 187.913 155.433 187.465 141.318C187.017 127.202 214.037 105.297 227.884 125.762C232.69 132.865 233.402 141.275 231.924 149.329L262.392 182.944L238.435 196.811L225.9 165.797Z"
        fill="#EFC298"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M178.766 132.866C181.848 138.191 188.545 140.121 193.969 137.356C197.516 136.541 201.777 134.983 206.232 132.788C206.721 134.593 207.523 136.5 208.685 138.508C209.711 140.28 210.995 142.047 212.46 143.747C212.751 142.104 213.578 140.664 214.84 139.933C218.372 137.889 222.509 139.367 224.292 142.448C226.555 146.357 225.932 150.493 222.764 152.629C229.031 156.604 235.622 158.514 239.727 156.138C247.523 151.625 247.041 138.006 240.563 126.813C240.335 126.42 240.101 126.034 239.861 125.655C243.548 125.936 247.366 126.892 251.211 127.854C259.382 129.898 267.678 131.973 275.098 127.678C289.945 119.084 278.53 85.7653 257.787 97.7723C243.68 105.938 237.93 112.009 233.708 118.508C230.607 115.87 227.192 114.119 223.865 113.442C222.991 113.154 221.85 113.054 220.498 113.132C219.656 113.153 218.83 113.252 218.026 113.431C213.653 114.195 207.889 116.285 201.936 119.46C200.824 120.052 199.748 120.661 198.712 121.279C195.516 115.798 188.48 113.935 182.978 117.12C177.465 120.311 175.579 127.361 178.766 132.866Z"
        fill="#191847"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M351.806 389.208C351.806 389.208 309.946 399.414 279.86 398.397C249.774 397.38 224.573 378.633 224.573 378.633C224.573 378.633 265.555 368.091 291.814 368.978C318.073 369.866 351.806 389.208 351.806 389.208Z"
        fill="#1F28CF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M255.551 408.742C255.831 408.35 256.071 407.921 256.266 407.454C260.292 397.8 323.046 294.297 329.594 275.208L262.957 272.955C257.978 287.469 234.688 378.821 231.228 397.087C221.289 425.748 199.67 518.928 197.095 525.347C194.387 532.1 208.086 539.692 212.085 531.414C218.447 518.241 233.781 481.715 240.816 459.333C247.41 438.351 252.841 419.457 255.551 408.742Z"
        fill="#EFC298"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M309.635 423.465C336.463 431.224 435.024 446.943 441.751 449.114C448.671 451.346 455.285 437.14 446.754 433.726C433.179 428.294 395.701 415.535 372.901 410.075C354.561 405.683 337.815 402.04 326.562 399.857C328.596 368.086 335.556 291.912 333.242 275.331L274.28 273.338C276.5 289.238 295.88 405.363 299.816 417.055C301.05 421.223 305.085 423.183 309.635 423.465Z"
        fill="#EFC298"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M444.11 431.71C443.933 430.94 444.424 430.169 445.204 430.048C447.516 429.69 452.009 429.105 454.219 429.572C457.27 430.218 462.909 432.474 462.909 432.474C462.161 436.016 449.458 496.149 449.458 496.149C449.458 496.149 440.734 496.897 441.21 491.411C441.686 485.925 441.906 482.277 441.906 482.277L434.871 449.409C434.792 449.038 435.035 448.674 435.408 448.605L440.906 447.589C440.906 447.589 444.26 443.126 444.913 440.031C445.378 437.831 444.599 433.837 444.11 431.71Z"
        fill="#E4E4E4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M214.164 528.674C214.891 528.366 215.737 528.716 215.992 529.464C216.745 531.68 218.1 536.006 218.024 538.265C217.919 541.384 216.678 547.334 216.678 547.334C213.062 547.211 151.682 545.137 151.682 545.137C151.682 545.137 149.431 536.669 154.912 536.185C160.394 535.701 164.022 535.285 164.022 535.285L195.143 522.643C195.496 522.5 195.896 522.676 196.029 523.032L197.984 528.273C197.984 528.273 202.957 530.804 206.117 530.91C208.361 530.986 212.155 529.526 214.164 528.674Z"
        fill="#E4E4E4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M333.051 275.325C333.051 275.325 294.455 262.848 259.299 272.832C249.988 309.391 229.893 323.347 224.537 379.7C263.06 400.508 312.588 368.766 352.279 389.129C364.701 362.942 350.731 298.395 333.051 275.325Z"
        fill="#CA7614"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M180.846 336.244L201.33 295.487L217.711 309.666L192.134 339.67C188.459 355.119 185.622 362.226 183.621 360.991C181.934 359.95 181.928 358.172 181.922 356.535C181.918 355.259 181.914 354.068 181.115 353.378C179.293 351.8 173.236 355.157 167.624 358.589C162.013 362.02 162.388 358.556 163.142 356.555C167.282 349.947 173.184 343.176 180.846 336.244ZM377.972 317.051C372.541 311.683 339.863 252.362 339.863 252.362L317.113 260.324C317.113 260.324 361.718 321.052 364.838 324.633C368.891 329.285 367.895 338.422 367.22 344.618C367.115 345.577 367.018 346.465 366.949 347.255C370.98 347.609 372.005 345.143 373.086 342.544C374.307 339.608 375.599 336.502 381.372 337.094C383.603 337.323 385.786 337.75 387.919 338.168C395.288 339.609 402.057 340.934 408.093 333.557C409.05 332.388 409.408 329.106 405.426 328.014C395.508 325.293 380.627 319.675 377.972 317.051Z"
        fill="#B28B67"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M242.135 179.273L232.151 180.916C229.913 227.012 214.292 273.591 185.287 320.655L228.658 347.17C252.811 286.083 260.937 228.862 242.135 179.273Z"
        fill="#191847"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M324.109 283.374L240.171 312.382C240.171 312.382 244.863 231.471 227.754 181.963L251.772 169.445C282.717 194.529 301.935 231.938 324.109 283.374Z"
        fill="#DDE3E9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M374.678 306.114C329.757 205.861 252.329 169.253 252.329 169.253L252.315 169.278C252.309 169.273 252.304 169.268 252.298 169.263L250.646 169.834C247.714 170.962 241.736 173.325 241.736 173.325L241.652 192.9C251.717 225.17 274.793 325.529 274.793 325.529L329.736 306.541C331.176 311.011 332.524 315.582 333.766 320.253L374.678 306.114Z"
        fill="#2F3676"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M329.875 306.974C323.636 287.499 315.649 269.948 307.111 254.519C312.347 274.519 317.318 299.045 314.568 312.263L329.875 306.974Z"
        fill="black"
        fill-opacity="0.1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M306.055 277.427L274.57 274.207L278.923 286.803L306.055 277.427Z"
        fill="white"
        fill-opacity="0.2"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="18.7701"
        y="0.485739"
        width="295.348"
        height="521.119"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="-1.76667" dy="19.4333" />
        <feGaussianBlur stdDeviation="15.0167" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="160.276"
        y1="23.5729"
        x2="175.484"
        y2="459.072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00903C" />
        <stop offset="1" stop-color="#00903C" stop-opacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'KvvTeaserSvg'
}
</script>

<style></style>
